import { values } from 'ramda'

import Layout from '@/app/component/layout/page'
import { PAGE } from '@/app/definitions'
import { AuthGuard, AuthHeader } from '@/app/module/auth'
import Notifications from '@/app/module/notifications'
import Account, { AccountTab } from '@/app/module/user/component/account'
import NotFoundPage from '@/app/page/not-found'
import { MatchProps } from '@/app/types'

type Props = {
  match: MatchProps<{
    tabName: string
  }>
}

export default function AccountPage({ match }: Props) {
  const validTabs = values(AccountTab) as string[]
  if (validTabs.indexOf(match.params.tabName) === -1) {
    return <NotFoundPage />
  }

  return (
    <AuthGuard url={match.url} path={match.path}>
      <Layout title="Profile - engageSPARK">
        <AuthHeader currentPage={PAGE.ACCOUNT.PROFILE.INDEX} />
        <Account tabName={match.params.tabName as AccountTab} />
        <Notifications />
      </Layout>
    </AuthGuard>
  )
}
